import type { Payout, RailHealth, RailStatus } from '@/types/portal';

export interface MarketRails {
  market: string;
  rails: RailStatus[];
  worstHealth: RailHealth;
}

const healthRank: Record<RailHealth, number> = {
  Operational: 0,
  Degraded: 1,
  Down: 2,
};

/** Group payout rails by market and surface the worst health in each market. */
export function railsByMarket(rails: RailStatus[]): MarketRails[] {
  const markets = Array.from(new Set(rails.map((rail) => rail.market)));
  return markets.map((market) => {
    const marketRails = rails.filter((rail) => rail.market === market);
    const worstHealth = marketRails.reduce<RailHealth>(
      (worst, rail) =>
        healthRank[rail.health] > healthRank[worst] ? rail.health : worst,
      'Operational',
    );
    return { market, rails: marketRails, worstHealth };
  });
}

export interface PayoutCounts {
  scheduled: number;
  processing: number;
  completed: number;
  failed: number;
  onHold: number;
}

export function payoutCounts(rows: Payout[]): PayoutCounts {
  return {
    scheduled: rows.filter((row) => row.status === 'Scheduled').length,
    processing: rows.filter((row) => row.status === 'Processing').length,
    completed: rows.filter((row) => row.status === 'Completed').length,
    failed: rows.filter((row) => row.status === 'Failed').length,
    onHold: rows.filter((row) => row.status === 'On hold').length,
  };
}

/** Payouts carrying an exception note that a finance user may need to act on. */
export function payoutExceptions(rows: Payout[]): Payout[] {
  return rows.filter((row) => Boolean(row.exception));
}